import {RecodeModule} from '@fantasmagames/slot/src/integration/RecodeModule';
import {Communicator} from '@fantasmagames/slot/src/logic/Communicator';
import {FreeGamesData} from '@fantasmagames/slot/src/logic/integration/FreeGamesData';
import {IRecodeError} from '@fantasmagames/slot/src/logic/integration/RecodeLogic';
import {Position} from '@fantasmagames/slot/src/modules/reels/ReelConstants';
import * as http from 'http';

export class RecodeIntegrator extends Communicator {
	protected options: any = {
		host: 'mobilewebserver9-recodedev.installprogram.eu',
		protocol: 'https:',
		path: '/XMan/x.x',
		method: 'POST',
		headers: {'content-type': 'text/xml'},
	};

	protected _module: RecodeModule;

	private _vApi: IRecodeVAPI;
	private _version: number = 5;

	private _mid: number; // 101128;
	private _cid: number; // 50300;
	private _sid: number; // 5002;

	private _sessionID: string;

	constructor(vApi: any) {
		super();
		// Described in the FAQ from ReCode.
		this._mid = (window as any).mgsCasinoParams.moduleID;
		this._cid = (window as any).mgsCasinoParams.clientID;
		this._sid = (window as any).mgsCasinoParams.casinoID;

		this._vApi = (vApi as any).API;

		this.subscribe();
	}

	public ping(): void {}
	public requestSavedData(): void {}

	public init(gameID: string, callback: Function): void {
		this.refresh(this._mid, this._cid, callback, null);
	}

	public saveData(...args: any[]): void {
		throw new Error('Method not implemented.');
	}

	public getAutoplayData(): IRecodeAutoPlayConfig {
		return this.vApi.Autoplay.getConfig();
	}

	public sendRequest(writeString: string, callback: Function): void {
		const cb = (response) => {
			let str = '';
			response.on('data', (chunk) => {
				str += chunk;
			});

			response.on('end', () => {
				// console.log(str);
				callback(str);
			});
		};

		const req = http.request(this.options, cb);

		req.write(writeString);

		req.end();
	}

	protected buildPacketConfig(verb: string, mid: number, cid: number, basePacket: string): IPacketConfig {
		const packetConfig: IPacketConfig = {
			verb,
			mid,
			cid,
			pktAttributes: {
				version: this._version,
			},
			basePkt: `${basePacket}`,
		};

		return packetConfig;
	}

	public freeSpin(...args: any[]): void {}

	// public showBonusBubble(): void {
	// This is handled in InfoModule as it is related to the viewable balance object.
	// }

	public spin(gameID: string, sessionID: string, betValue: IRecodeBet, callback: Function, freeRoundsData?: FreeGamesData): void {
		let chipSize = 0;
		let numChips = 0;
		if (betValue) {
			chipSize = betValue.chipSize;
			numChips = betValue.numChips;
		}
		let basePacket: string;
		if (freeRoundsData) {
			basePacket = `<Request verbex="Spin" chipSize="${freeRoundsData.betData.chipSize}" numChips="${freeRoundsData.betData.numChips}" offerId="${freeRoundsData.offerID}" instanceId="${freeRoundsData.instanceID}"/>`;
		} else {
			basePacket = `<Request verbex="Spin" chipSize="${chipSize}" numChips="${numChips}"/>`;
		}
		const packetConfig = this.buildPacketConfig('AdvSlot', this._mid, this._cid, basePacket);
		this.sendPacket(packetConfig, callback, null);
	}

	/**
	 *  Initialize data and refreshing the game.
	 * @param mid
	 * @param cid
	 * @param callback
	 * @param callbackObj
	 */
	public refresh(mid: number, cid: number, callback: Function, callbackObj: any): void {
		const basePacket: string = `<Request verbex='Refresh'/>`;
		const packetConfig = this.buildPacketConfig('AdvSlot', mid, cid, basePacket);

		this.sendPacket(packetConfig, callback, callbackObj);
	}

	public respin(mid: number, cid: number, callback: Function, callbackObj: any): void {}

	public freespin(callback: Function): void {
		const basePacket: string = `<Request verbex='FreeSpin'/>`;
		const packetConfig = this.buildPacketConfig('AdvSlot', this._mid, this._cid, basePacket);

		this.sendPacket(packetConfig, callback, null);
	}

	public pick(chestIndex: number, callback: Function, callbackObj: any, freeRoundsData?: FreeGamesData): void {
		let basePacket: string;
		if (freeRoundsData) {
			basePacket = `<Request verbex='Bonus' bonusName='ChestBonus' action='2' id='${chestIndex}' offerId='${freeRoundsData.offerID}' instanceId='${freeRoundsData.instanceID}'/>`;
		} else {
			basePacket = `<Request verbex='Bonus' bonusName='ChestBonus' action='2' id='${chestIndex}'/>`;
		}
		const packetConfig = this.buildPacketConfig('AdvSlot', this._mid, this._cid, basePacket);

		this.sendPacket(packetConfig, callback, callbackObj);
	}

	public skippick(chestIndex: number, callback: Function, callbackObj: any, freeRoundsData?: FreeGamesData): void {
		let basePacket: string;
		if (freeRoundsData) {
			basePacket = `<Request verbex='Bonus' bonusName='ChestBonus' action='1' id='${chestIndex}' offerId='${freeRoundsData.offerID}' instanceId='${freeRoundsData.instanceID}'/>`;
		} else {
			basePacket = `<Request verbex='Bonus' bonusName='ChestBonus' action='1' id='${chestIndex}'/>`;
		}
		const packetConfig = this.buildPacketConfig('AdvSlot', this._mid, this._cid, basePacket);

		this.sendPacket(packetConfig, callback, callbackObj);
	}

	public openChest(chestIndex: number, callback: Function, callbackObj: any, freeRoundsData?: FreeGamesData): void {
		let basePacket: string;
		if (freeRoundsData) {
			basePacket = `<Request verbex='Bonus' bonusName='ChestBonus' action='0' id='${chestIndex}' offerId='${freeRoundsData.offerID}' instanceId='${freeRoundsData.instanceID}'/>`;
		} else {
			basePacket = `<Request verbex='Bonus' bonusName='ChestBonus' action='0' id='${chestIndex}'/>`;
		}
		const packetConfig = this.buildPacketConfig('AdvSlot', this._mid, this._cid, basePacket);

		this.sendPacket(packetConfig, callback, callbackObj);
	}

	public avalanche(mid: number, cid: number, callback: Function, callbackObj: any): void {}

	public rejectFreeGames(offerID: string, instanceID: string, callback: Function, callbackObj: any): void {
		const basePacket = `<Request verbex='RejectFreeGames'><FreeGames><FreeGame offerId='${offerID}' instanceId='${instanceID}' /></FreeGames></Request>`;
		const packetConfig = this.buildPacketConfig('AdvSlot', this._mid, this._cid, basePacket);

		this.sendPacket(packetConfig, callback, callbackObj);
	}

	// Api communication.
	public api_balanceUpdate(playerBalance: number): void {
		//  This should be when the change in
		// balance needs to be displayed (e.g.
		// spin started, count-up has completed).
		const event = this.getEventsList().balanceUpdate;
		this.sendEvent(event, playerBalance);
	}

	public api_betSizeUpdate(betSizeAmount: number): void {
		// This should be when the change in bet
		// needs to be displayed (e.g. player
		// changes bet in console).
		const event = this.getEventsList().betSizeUpdate;
		this.sendEvent(event, betSizeAmount);
	}

	public api_gameplayStart(): void {
		// This would be as soon as an event
		// has started in game that should block
		// interaction, (e.g. spin button being
		// clicked, free spins has started, gamble
		// feature has started, etc.).
		const event = this.getEventsList().gameplayStart;
		this.sendEvent(event);
	}

	public api_gameplayPause(): void {
		//         This would be as soon as an event
		// which blocked interaction in the game
		// has completed, (e.g. spin has resolved
		// and result has been shown, free spins
		// has completed, gamble feature has
		// completed, etc.).
		const event = this.getEventsList().gameplayPause;
		this.sendEvent(event);
	}

	public api_playerInformationRecieved(playersBalance: number): void {
		//         This should be when the refresh
		// packet has been received.
		const event = this.getEventsList().playerInformationRecieved;
		this.sendEvent(event, playersBalance);
	}

	public api_gameSetMute(setMute: boolean): void {
		//         This should be when the mute option
		// has changed.
		// Also set V.API.Core.muteSound to current value.
		this.vApi.Core.muteSound(setMute);

		const event = this.getEventsList().gameSetMute;
		this.sendEvent(event, !setMute); // Invert the value since they are using the inverted value. False : muted, True : unmuted.
	}

	public api_winUpdate(winAmount: number): void {
		// This should be when the win amount
		// needs to be displayed (e.g. count-up
		// has completed).
		const event = this.getEventsList().winUpdate;
		this.sendEvent(event, winAmount);
	}

	public api_gamemenuOpen(): void {
		// Sent when the hamburger menu in
		// Play.Next is opened. This tells V to
		// hide certain elements that may clash
		// wth the menu.
		const event = this.getEventsList().gamemenuOpen;
		this.sendEvent(event);
	}

	public api_gamemenuClosed(): void {
		// Sent when the hamburger menu in
		// Play.Next is closed. This te0lls V to
		// show certain elements that were
		// hidden when the menu opened.
		const event = this.getEventsList().gamemenuClosed;
		this.sendEvent(event);
	}

	public api_autoPlayStarted(): void {
		// Sent when the game enters Autoplay
		const event = this.getEventsList().autoPlayStarted;
		this.sendEvent(event);
	}

	public api_autoPlayStopped(): void {
		// Sent when the game exits Autoplay

		// Will probably also need to implement win and loss limit.

		//         Stop from BaseGame
		// When the game stops autoplay, it must send an autoplayStopped signal to inform the GameFramework of this. The GameFramework resets
		// the AutoPlay module by clearing the limits and amounts, and set the isActive property to false.
		// V.API.Events.getEventsList('gameEvent').autoPlayStopped

		const event = this.getEventsList().autoPlayStopped;
		this.sendEvent(event);
	}

	public api_gameRoundCompleted(): void {
		// Sent when end of game
		// round including the win animation
		// count up stop & balance update. In
		// free spin and bonus features at the
		// end of this feature ,i.e games back to
		// base game.
		const event = this.getEventsList().gameRoundCompleted;
		this.sendEvent(event);
	}

	public api_server_systemBalanceUpdate(eventName: string, data: {value: number}): void {
		// Should update the in game balance. Send the correct event to eventhandler.
		this.module.onServerSystemBalanceUpdate(data.value);
	}

	public api_server_pluginSetMute(eventName: string, options: any): void {
		// Should mute the game sounds.
		let value = false;

		if (options) {
			if (options.value) {
				value = options.value;
			}
		}

		// Mute should be inverted because that is how they send it.
		this.module.onServerSetMute(!value);
	}

	public api_server_gameplayResume(...args: any[]): void {
		// Should restore gameplay from a paused state.
		this.module.onServerGameplayResume();
	}

	public api_server_autoPlayInterrupt(...args: any[]): void {
		//         Stop from BaseGame Framework
		// AutoPlay stops from the mobile HTML5 casino core GameFramework if the player limits are exceeded or any UI blocking event occurs. The
		// GameFramework will emit the autoplayInterrup signal in this scenario
		// V.API.Events.getEventsList('gameEvent').autoPlayInterrupt
		// The game must end autoplay when it receives this signal.
		// Deprecated
		// This section is deprecated by the introduction of the AutoPlay Wager Limits API. V will not inspect spin requests or response
		// packets, instead the limits are calculated by calling V.API.Autoplay.verifyWagerLimits(wagerParameters) before each spin.
		// The game framework also removes the packet listeners attached to the spin packets by adding the removePacketCheck method to the
		// PacketInspector module. The game framework displays the AutoPlay limits notification when limits are reached.
		// Translations are required for
		// the message text, “Your AutoPlay limit has been reached”.

		this.module.onServerAutoplayInterrupt(args);
	}

	public api_server_preloaderRemoved(...args: any[]): void {
		// BaseGame should start here, which doesn't make sense to implement acccording to ReCode docs atm.'
		// this.module.onServerPreloaderRemoved();
	}

	public server_launchLobby(): void {
		this.vApi.Core.launchLobby();
	}

	public server_launchBanking(): void {
		this.vApi.Core.launchBanking();
	}

	public setModule(module: RecodeModule): void {
		this._module = module;
	}

	protected errorCallback(): void {}

	public api_showCoinSizeChangedDialog(callback: Function): void {
		this.showingErrorDialog();

		const extraCallback = () => {
			this.closingErrorDialog();
			this.module.emitValidatedBetCoinSizeChanged();
			if (callback) {
				callback();
			}
		};

		this.vApi.Dialog.showCoinSizeChangedDialog(extraCallback);
	}

	/**
	 * Quote from Grant: "Hello, I’ve never used Chip Size changed, coin should work in all instances. The Chip dialog looks a lot uglier!""
	 *
	 * @param {Function} callback
	 * @memberof RecodeIntegrator
	 */
	public api_showChipSizeChangedDialog(callback: Function): void {
		return;
	}

	public api_showPracticePlayProgressiveNotAllowedDialog(callback: Function): void {
		this.showingErrorDialog();
		const extraCallback = () => {
			this.closingErrorDialog();
			if (callback) {
				callback();
			}
		};

		this.vApi.Dialog.showPracticePlayProgressiveNotAllowedDialog(extraCallback);
	}

	public api_showInsufficientFundsDialog(callback: Function): void {
		this.showingErrorDialog();
		const extraCallback = () => {
			this.closingErrorDialog();
			if (callback) {
				callback();
			}
		};

		this.vApi.Dialog.showInsufficientFundsDialog(extraCallback);
	}

	public isBankingAvailable(): boolean {
		return this.vApi.Core.isBankingAvailable();
	}

	public api_showErrorMessage(data: IRecodeError): void {
		const type = data.attributes.servercode.toLowerCase();

		this.showingErrorDialog();

		if (type && data.attributes.text) {
			this.vApi.Dialog.showErrorDialog(data.attributes.text, this.closingErrorDialog.bind(this, this.vApi.Core.launchLobby));
		}

		// if (type === 'error') {
		// 	this.vApi.Dialog.showErrorDialog(data.attributes.text, this.closingErrorDialog.bind(this, this.vApi.Core.launchLobby));
		// }

		// if (type === 'coinSizeChanged') {
		// 	this.vApi.Dialog.showCoinSizeChangedDialog(() => {
		// 		console.log('CoinSizeChanged');
		// 	});
		// }
		// if (type === 'betWillBeAdjusted') {
		// 	this.vApi.Dialog.showBetWillBeAdjustedDialog(() => {
		// 		console.log('BetSizeWillBeAdjusted');
		// 	});
		// }

		// this.vApi.Dialog.showErrorDialog(data.value, this.vApi.Core.launchLobby);
	}

	protected showingErrorDialog(callback: Function = null): void {
		if (this._module) {
			this._module.onShowErrorDialog();
		}

		if (callback && typeof callback === 'function') {
			callback();
		}
	}

	protected closingErrorDialog(callback: Function = null): void {
		if (this._module) {
			this._module.onCloseErrorDialog();
		}

		if (callback && typeof callback === 'function') {
			callback();
		}
	}

	private getEventsList(id: string = 'gameEvent'): any {
		return this.vApi.Events.getEventsList('gameEvent');
	}

	private sendPacket(packetConfig: any, callback: Function, callbackObj: any): void {
		// console.log(`Send packet: ${JSON.stringify(packetConfig)}`);
		this.vApi.Core.sendPacket(packetConfig, callback, callbackObj);
	}

	private sendEvent(eventEnum: any, data: any = null): void {
		this.vApi.Events.sendEvent('gameEvent', eventEnum, data);
	}

	private subscribe(): void {
		// private subscribe(gameEvent: string, callback: Function, callbackObj: any): void {
		// Needs implementation.
		const vEventTypeEnum = this.vApi.Events.getEventsTypeEnumList();
		const vGameEventEnum: IEventsList = this.vApi.Events.getEventsList((vEventTypeEnum as any).gameEvent);

		// this.vApi.Events.subscribe(vEventTypeEnum[`${gameEvent}`], this.successCallback, this);
		// this.vApi.Events.unsubscribe(vEventTypeEnum[`${gameEvent}`], this.successCallback, this);
		this.vApi.Events.subscribe('gameEvent', this.successCallback, this);

		// return this.vApi.Events.subscribe(gameEvent, callback, callbackObj);
	}

	private unsubscribe(): number {
		// return this.vApi.Events.unsubscribe(gameEvent, callback, callbackObj);
		return this.vApi.Events.unsubscribe('gameEvent', this.successCallback, this);
	}

	private successCallback(eventName: string, data: any): void {
		const vEventTypeEnum = this.vApi.Events.getEventsTypeEnumList();
		const vGameEventEnum: IEventsList = this.vApi.Events.getEventsList((vEventTypeEnum as any).gameEvent);

		switch (eventName) {
			case vGameEventEnum.systemBalanceUpdate:
				this.api_server_systemBalanceUpdate(eventName, data);
				// things to do if this event is dispatched from V
				break;
			case vGameEventEnum.pluginSetMute:
				this.api_server_pluginSetMute(eventName, data);

				// things to do if this event is dispatched from V
				break;
			case vGameEventEnum.gameplayResume:
				this.api_server_gameplayResume(eventName, data);

				// things to do if this event is dispatched from V
				break;
			case vGameEventEnum.autoPlayInterrupt:
				this.api_server_autoPlayInterrupt(eventName, data);

				// things to do if this event is dispatched from V
				break;
			case vGameEventEnum.preloaderRemoved:
				this.api_server_preloaderRemoved(eventName, data);

				// things to do if this event is dispatched from V
				break;
			case vGameEventEnum.displayError:
				// this.api_showErrorMessage(eventName, data);

				break;
			default:
				break;
		}
	}

	public get version(): number {
		return this._version;
	}

	private get vApi(): IRecodeVAPI {
		return this._vApi;
	}

	private get mid(): number {
		return this._mid;
	}

	private get cid(): number {
		return this._cid;
	}

	private get module(): RecodeModule {
		return this._module;
	}
}

// Requests
//
// V.API.Events.getEventsList('gameEvent').balanceUpdate;
// V.API.Events.getEventsList('gameEvent').betSizeUpdate;
// V.API.Events.getEventsList('gameEvent').gameplayStart;
// V.API.Events.getEventsList('gameEvent').gameplayPause;
// V.API.Events.getEventsList('gameEvent').playerInformationRecieved;
// V.API.Events.getEventsList('gameEvent').gameSetMute;
// V.API.Events.getEventsList('gameEvent').winUpdate;
// V.API.Events.getEventsList('gameEvent').gamemenuOpen;
// V.API.Events.getEventsList('gameEvent').gamemenuClosed;
// V.API.Events.getEventsList('gameEvent').autoPlayStarted;
// V.API.Events.getEventsList('gameEvent').autoPlayStopped;
// V.API.Events.getEventsList('gameEvent').gameRoundCompleted;

// Serverside posts
//
// V.API.Events.getEventsList('gameEvent').systemBalanceUpdate
// V.API.Events.getEventsList('gameEvent').pluginSetMute
// V.API.Events.getEventsList('gameEvent').gameplayResume
// V.API.Events.getEventsList('gameEvent').autoPlayInterrupt
// V.API.Events.getEventsList('gameEvent').preloaderRemoved

// Interfaces based on provided documentation.
export interface IRecodeVAPI {
	Account: IAccount;
	AutoPlay: IRecodeAutoPlay;
	Autoplay: IRecodeAutoplay;
	BonusBubble: IBonusBubble;
	Core: ICore;
	Dialog: IDialog;
	Events: IEvents;
	Fullscreen: IFullscreen;
	GameAnalytics: any;
	GameStatus: IGameStatus;
	Metrics: any;
	Scaler: any;
	SlotAnalytics: any;
	Sound: any;
	Storage: IRecodeStorage;
	SystemConsole: any;
	SystemMenu: ISystemMenu;
}

interface IBonusBubble {
	bubbleEnabled: {(): boolean};
	onBubbleTrigger: {(show: boolean, position: Position | null): void};
}

export interface IRecodeStorage {
	setItem: {(key: string, data: string): void};
	removeItem: {(key: string): void};
	hasItem: {(key: string): boolean};
	getLength: {(): number};
	getKey: {(index: number): string};
	getItem: {(key: string): string};
	each: {(callback: {(key: string, value: string): void}, keyFilter?: string): void};
}

interface IGameStatus {
	getEnum: {(): string[]};
	getCurrentStatus: {(): string};
	setCurrentStatus: {(status: string): void};
}

interface IFullscreen {
	isEnabled: {(): boolean};
	hasBrowserSupport: {(): boolean};
	isFullscreen: {(): boolean};
	isOverlayVisible: {(): boolean};
	showOverlay: {(): boolean};
	hideOverlay: {(): boolean};
	requestFullscreen: {(): boolean};
	exitFullscreen: {(): void};
}

/**
 *
 * @interface IAccount
 * Account specific functions.
 */
interface IAccount {
	isPlayForRealEnabled: Function;
}

export interface IRecodeAutoplayEvents {
	autoPlayStarted: string;
	autoPlayStopped: string;
	autoPlayInterrupt: string;
}

/**
 * Not to be confused with the other Autoplay with a small p.
 *
 * @interface IRecodeAutoPlay
 */
interface IRecodeAutoPlay {
	VerifyWagerLimitsParameters: Function;
	VerifyWagerLimitsResult: Function;
	WagerLimitReasons: IRecodeWagerLimitReasons;
}

interface IRecodeWagerLimitReasons {
	lossLimit: string;
	none: string;
	wagerCount: string;
	winLiomit: string;
}

/**
 *
 * Note the small p in autoplay for this particular component.
 * @interface IRecodeAutoplay
 */
interface IRecodeAutoplay {
	init: {(options: IRecodeAutoPlayOptions, startCallback: Function, cancelCallback: Function, callBackObj: any): void};
	getConfig: {(): IRecodeAutoPlayConfig};
	stop: Function;
	events: IRecodeAutoplayEvents;
}

/**
 * @interface IAutoPlayOptions
 * * __betSizeOptions__: (Array) values games want to populate under Coins Bet dropdown. V shows these values as they are.
 * * __coinSizeOptions__: (Array) values games want to populate under Coin Size dropdown. V divides these with 100 and displays them.
 * * __isJackpotAvailable__: (Boolean) (Optional)BaseGame must set this to TRUE only if current game has Progressive Jackpot.
 * * __numPaylines__: (int) paylines count- This is used by V to determine the bet size from the settings chosen in the custom dialog
 * * __selectedBetSize__: (int) Bet Value in Cents that was selected as BET before calling Autoplay.
 * * __selectedCoinSize__: (int) Value that needs to be selected by default under Coin Size Dropdown (coinSizeOptions)
 * * __selectedCoinsBet__: (int) Value that needs to be selected by default under Coin Bet Dropdown (betSizeOptions)
 * * __spins__: (text) selected spins eg “25”, “custom” etc "custom" if games wants to show Custom Dialog,
 * "untilStop" if player selects until stop.
 * * __winLimit__: (int) The selected winLimit for autoplay. This is optional and only required in regulated markets
 * if the game handles it's own custom settings.
 * * __lossLimit__: (int) The selected lossLimit for autoplay. This is optional and only required in regulated markets
 * if the game handles it's own custom settings.
 */
export interface IRecodeAutoPlayOptions {
	betSizeOptions: number[];
	coinSizeOptions: number[];
	isJackpotAvailable: boolean;
	numPaylines: number;
	selectedBetSize: number;
	selectedCoinSize: number;
	selectedCoinsBet: number;
	spins: string;
	winLimit: number;
	lossLimit: number;
}

/**
 *
 * @interface IAutoPlayConfig
 *
 * In DotCom market, Autoplay is available without any custom settings available. The player opens the game, select any spin value from the
 * game console and then AutoPlay commences without any custom screen setting showing.
 *
 * To meet United Kingdom regulated market requirements, the alwaysDisplayCustomScreen flag is true to ensure the custom settings screen
 * is always displayed. If games are to show their own custom settings, they need to check this value.
 */
export interface IRecodeAutoPlayConfig {
	enabled: boolean;
	alwaysDisplayCustomScreen: boolean;
	spinCount: number[];
	hasCustom: boolean;
	untilStop: boolean;
	maxSpinsUntilStop: string;
	jackpotEnabled: boolean;
	winLimitEnabled: boolean;
	winLimitAmounts: string[];
	winLimitDefault: string;
	lossLimitEnabled: boolean;
	lossLimitDefault: string;
	lossLimitAmounts: string[];
	stopWhenGameIsHidden: boolean;
	useWagerLimitApi: boolean;
}

export interface IRecodeAutoPlayExtraConfig {
	hasCustom: boolean;
	alwaysDisplayCustomScreen: boolean;
	useWagerLimitApi: boolean;
}

/**
 *
 * @interface ICore
 * Core inteface for communicating with the Server-API.
 */
interface ICore {
	isResponsibleGamingAvailable: {(): boolean};
	isHelpAvailble: {(): boolean};
	muteSound: {(mute: boolean): void};
	isSoundMuted: {(): boolean};
	isBankingAvailable: {(): boolean};
	isLobbyAvailable: {(): boolean};
	launchBanking: {(): void};
	launchLobby: {(): void};
	displayInsufficientFunds: {(): void}; // Will be deprecated according to Game Integration into V docs from 25th Feb.
	sendPacket: {(pktConfig: IPacketConfig, callback: Function, callbackObj: any): void};
}

/**
 * Send-packet definition.
 *
 * ### @properties: verb,  mid,  cid,  pktAttributes,  basePkt
 *
 *
 *  * **basePkt**: needs to be standard XML and is __case sensitive__.
 *
 *  * **pktAttributes**: version, the version to be used would have been supplied by Services team that runs Veyron.
 *
 *  #### This function will return a JSON object that is a representation of the example XMLs you would have been sent for your game.
 *
 */
interface IPacketConfig {
	verb: string;
	mid: number;
	cid: number;
	pktAttributes: {
		version: number;
	};
	basePkt: string;
}

/**
 * @interface IDialog
 */
interface IDialog {
	showInsufficientFundsDialog: {(callback?: Function): void};
	showCoinSizeChangedDialog: {(callback?: Function): void};
	showChipSizeChangedDialog: {(callback?: Function): void};
	showPracticePlayProgressiveNotAllowedDialog: {(callback?: Function): void};
	showErrorDialog: {(message: string, callback: Function): void};
}

interface IErrorData {
	type: string;
	call: Function | null;
	value?: any;
}

interface ISystemMenu {
	getSystemMenuItems: {(): any};
}

interface IEvents {
	sendEvent: {(gameEvent: string, eventEnum: string, data: any): void};
	getEventsList: {(eventType: string): any};
	subscribe: {(gameEvent: string, callback: Function, callbackObj: any): number};
	unsubscribe: {(gameEvent: string, callback: Function, callbackObj: any): number};
	getEventsTypeEnumList: {(): any[]};
}

export interface IRecodeBet {
	chipSize: number;
	numChips: number;
	activePaylines?: number;
	totalValue: number;
}

interface IEventsList {
	autoPlayStarted: string;
	autoPlayStopped: string;
	autoPlayInterrupt: string;
	balanceUpdate: string;
	balanceUpdateTwo: string;
	betSizeUpdate: string;
	bonusgameComplete: string;
	bonusgameStarted: string;
	deviceLocked: string;
	displayError: string;
	externalInfoUpdate: string;
	fatalError: string;
	fullscreenOverlayShown: string;
	fullscreenOverlayRemoved: string;
	gameInitialized: string;
	gamemenuClosed: string;
	gamemenuOpen: string;
	gameMetric: string;
	gameplayPause: string;
	gameplayResume: string;
	gameplayStart: string;
	gameReady: string;
	gameRoundCompleted: string;
	gamescreenBusy: string;
	gamescreenFree: string;
	gameSetMute: string;
	navigationSwipeLeft: string;
	navigationSwipeRight: string;
	loadProgressUpdate: string;
	megaWinSummaryClosed: string;
	megaWinTriggered: string;
	orientationChanged: string;
	overlayRemoved: string;
	overlayShown: string;
	playerInformationRecieved: string;
	pluginSetMute: string;
	portraitOverlayRemoved: string;
	portraitOverlayShown: string;
	preloaderRemoved: string;
	resizeWindowOverlayRemoved: string;
	resizeWindowOverlayShown: string;
	showMegaWinSummary: string;
	symbolsLoadingEnd: string;
	symbolsLoadingStart: string;
	systemBalanceUpdate: string;
	topBarBalanceUpdate: string;
	tutorialDismissed: string;
	tutorialShown: string;
	winUpdate: string;
	viewPorterUpdated: string;
	gameLoaderReady: string;
	gameReadyToUnload: string;
	preloaderStarts: string;
	willClosingGameGenerateUnfinishedGameResponse: string;
	playerAttentionRequired: string;
	windowResized: string;
	resultShown: string;
	sessionActivity: string;
	preventGamePlay: string;
	realityCheckLimitReached: string;
	soundOff: string;
	soundOn: string;
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/integration/RecodeIntegrator.ts